import { BrowserModule } from '@angular/platform-browser'
import {
	HttpClientModule,
	//HttpClient, HttpHandler
} from '@angular/common/http'
import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { HttpModule } from '@angular/http'

import {
	ErrorHandler, NgModule, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID
	//	, NO_ERRORS_SCHEMA
} from '@angular/core'
import { IonicApp, IonicModule } from 'ionic-angular'
//import { IonicErrorHandler } from 'ionic-angular';
import { IonicStorageModule } from '@ionic/storage'

//import { SplashScreen } from '@ionic-native/splash-screen';
//import { PinDialog } from '@ionic-native/pin-dialog';
//import { Toast } from '@ionic-native/toast';
//import { NativeStorage } from '@ionic-native/native-storage';
import { UniqueDeviceID } from '@ionic-native/unique-device-id'
//import { IonPullupModule } from 'ionic-pullup';

import { AddressEditPage } from '../pages/address-edit/address-edit'
import { AddressCreatePage } from '../pages/address-create/address-create'
import { CallPage } from '../pages/call/call'
import { CondominiumEditPage } from '../pages/condominium-edit/condominium-edit'
import { CondominiumIndexPage } from '../pages/condominium-index/condominium-index'
import { CondominiumIntercomPage } from '../pages/condominium-intercom/condominium-intercom'
import { CondominiumShowPage } from '../pages/condominium-show/condominium-show'
import { CondominiumWritePage } from '../pages/condominium-write/condominium-write'
import { ControlPanelPage } from '../pages/control-panel/control-panel'
import { DashboardPage } from '../pages/dashboard/dashboard'
import { DeviceIndexPage } from '../pages/device-index/device-index'
import { DeviceShowPage } from '../pages/device-show/device-show'
import { DeviceEditPage } from '../pages/device-edit/device-edit'
import { LoginPage } from '../pages/login/login'
//import { IncomingPage } from '../pages/incoming/incoming';
import { HistoryPage } from '../pages/history/history'
import { HeatingConsumptionPage } from '../pages/heating-consumption/heating-consumption'
import { HousingUnitCreatePage } from '../pages/housing-unit-create/housing-unit-create'
import { HousingUnitEditPage } from '../pages/housing-unit-edit/housing-unit-edit'
import { HousingUnitIndexPage } from '../pages/housing-unit-index/housing-unit-index'
import { HousingUnitShowPage } from '../pages/housing-unit-show/housing-unit-show'
import { HousingUnitUserCreatePage } from '../pages/housing-unit-user-create/housing-unit-user-create'
import { MessageShowPage } from '../pages/message-show/message-show'
import { MessageCreatePage } from '../pages/message-create/message-create'
import { MessageCreateIntercomPage } from '../pages/message-create-intercom/message-create-intercom'
import { MessageCreateReportPage } from '../pages/message-create-report/message-create-report'
import { MessageModalPage } from '../pages/message-modal/message-modal'
import { SettlementModalPage } from '../pages/settlement-modal/settlement-modal'
import { TabCallsPage } from '../pages/tab-calls/tab-calls'
import { TabMessagesPage } from '../pages/tab-messages/tab-messages'
import { UserAddPage } from '../pages/user-add/user-add'
import { UserEditPage } from '../pages/user-edit/user-edit'
import { UserIndexPage } from '../pages/user-index/user-index'
import { UserShowPage } from '../pages/user-show/user-show'

/*
PLUGIN NATIVI
*/
import { AndroidFullScreen } from '@ionic-native/android-full-screen'
import { AndroidPermissions } from '@ionic-native/android-permissions'
import { Autostart } from '@ionic-native/autostart'
import { BackgroundMode } from '@ionic-native/background-mode'
import { Device } from '@ionic-native/device'
import { File } from '@ionic-native/file'
import { FileTransfer } from '@ionic-native/file-transfer'
import { Insomnia } from '@ionic-native/insomnia'
import { LocalNotifications } from '@ionic-native/local-notifications'
import { Badge } from '@ionic-native/badge'
import { NativeAudio } from '@ionic-native/native-audio'
//import { NativeRingtones } from '@ionic-native/native-ringtones';
import { Media } from '@ionic-native/media'
import { NavigationBar } from '@ionic-native/navigation-bar'
import { Network } from '@ionic-native/network'
import { OpenNativeSettings } from '@ionic-native/open-native-settings'
import { TextToSpeech } from '@ionic-native/text-to-speech'
import { ScreenOrientation } from '@ionic-native/screen-orientation'
//import { WebIntent } from '@ionic-native/web-intent';
//import { StatusBar } from '@ionic-native/status-bar';
//import { RoundProgressModule } from 'angular-svg-round-progressbar'; importato nelle relative pagine

//import { DatePicker } from '@ionic-native/date-picker'; NON FUNZIONA SU WEB
import { CalendarModule } from "ion2-calendar"

import { ClientApp } from './app.component'

import { AuthInterceptor } from '../interceptors/auth/auth'
import { IdentifierInterceptor } from '../interceptors/identifier/identifier'


import { AccountProvider } from '../providers/account/account'
import { AddressProvider } from '../providers/address/address'
import { AuthProvider } from '../providers/auth/auth'
import { CondominiumProvider } from '../providers/condominium/condominium'
import { ConfigProvider } from '../providers/config/config'
import { DeviceProvider } from '../providers/device/device'
import { FlavourProvider } from '../providers/flavour/flavour'
import { HousingUnitProvider } from '../providers/housing-unit/housing-unit'
import { LocationProvider } from '../providers/location/location'
import { MessageProvider } from '../providers/message/message'
import { UserProvider } from '../providers/user/user'
import { SecurityCamProvider } from '../providers/security-cam/security-cam'
import { SignalingSocketIoProvider } from '../providers/signaling/socket_io'
//import { SignalingFirebaseProvider } from '../providers/signaling/firebase'
import { WebrtcProvider } from '../providers/webrtc/webrtc'
import { AndroidBridgeProvider } from '../providers/android/android-bridge';

//import { CondominiumItemComponent } from '../components/condominium-item/condominium-item';
//Moduli delle pagine
import { AddressCreatePageModule } from '../pages/address-create/address-create.module'
import { AddressEditPageModule } from '../pages/address-edit/address-edit.module'
import { CondominiumEditPageModule } from '../pages/condominium-edit/condominium-edit.module'
import { CondominiumIntercomPageModule } from '../pages/condominium-intercom/condominium-intercom.module'
import { CondominiumIndexPageModule } from '../pages/condominium-index/condominium-index.module'
import { CondominiumShowPageModule } from '../pages/condominium-show/condominium-show.module'
import { CondominiumWritePageModule } from '../pages/condominium-write/condominium-write.module'
import { ControlPanelPageModule } from '../pages/control-panel/control-panel.module'
import { CreditsModalPageModule } from '../pages/credits-modal/credits-modal.module'
import { DashboardPageModule } from '../pages/dashboard/dashboard.module'
import { DeviceEditPageModule } from '../pages/device-edit/device-edit.module'
import { DeviceIndexPageModule } from '../pages/device-index/device-index.module'
import { DeviceShowPageModule } from '../pages/device-show/device-show.module'
import { LoginPageModule } from '../pages/login/login.module'
import { HeatingConsumptionPageModule } from '../pages/heating-consumption/heating-consumption.module'
import { HistoryPageModule } from '../pages/history/history.module'
import { HousingUnitEditPageModule } from '../pages/housing-unit-edit/housing-unit-edit.module'
import { HousingUnitCreatePageModule } from '../pages/housing-unit-create/housing-unit-create.module'
import { HousingUnitIndexPageModule } from '../pages/housing-unit-index/housing-unit-index.module'
import { HousingUnitIntercomPageModule } from '../pages/housing-unit-intercom/housing-unit-intercom.module'
import { HousingUnitShowPageModule } from '../pages/housing-unit-show/housing-unit-show.module'
import { HousingUnitIntercomPage } from '../pages/housing-unit-intercom/housing-unit-intercom'
import { HousingUnitUserCreatePageModule } from '../pages/housing-unit-user-create/housing-unit-user-create.module'
//import { IncomingPageModule } from '../pages/incoming/incoming.module';
import { MessageCreatePageModule } from '../pages/message-create/message-create.module'
import { MessageCreateIntercomPageModule } from '../pages/message-create-intercom/message-create-intercom.module'
import { MessageCreateReportPageModule } from '../pages/message-create-report/message-create-report.module'
import { MessageCreateAudioPageModule } from '../pages/message-create-audio/message-create-audio.module'
import { MessageModalPageModule } from '../pages/message-modal/message-modal.module'
import { MessageShowPageModule } from '../pages/message-show/message-show.module'
import { SettlementModalPageModule } from '../pages/settlement-modal/settlement-modal.module'
import { TabMessagesPageModule } from '../pages/tab-messages/tab-messages.module'
import { TabCallsPageModule } from '../pages/tab-calls/tab-calls.module'
import { TimetableModalPageModule } from '../pages/timetable-modal/timetable-modal.module'
import { UserAddPageModule } from '../pages/user-add/user-add.module'
import { UserEditPageModule } from '../pages/user-edit/user-edit.module'
import { UserIndexPageModule } from '../pages/user-index/user-index.module'
import { UserShowPageModule } from '../pages/user-show/user-show.module'

import { ComponentsModule } from '../components/components.module'
//import { PipesModule } from '../pipes/pipes.module';
import { CallPageModule } from '../pages/call/call.module'
import { AudioProvider } from '../providers/audio/audio'
import { InterappProvider } from '../providers/interapp/interapp'

//NOTE Sembra che sia bacato, va in loop!
//import safeStringify from 'fast-safe-stringify';

//import { Logger } from '../util/logger/logger';
//import { JL } from 'jsnlog';

/*

*/

/**
Logger
RIMOSSI PERCHE POTREBBERO AVER CREATO INSTABILITA
TODO Mettere un logger remoto che sicuramente non produca crash con errori di vario genere
*/
/*


import safeStringify from 'fast-safe-stringify';


//opzioni globali
JL.setOptions({
serialize: safeStringify
})

//logger ajax
var ajaxLogger = JL.createAjaxAppender('ajaxAppender');
ajaxLogger.setOptions({
level: JL.getErrorLevel(),
batchSize: 8,
maxBatchSize: 64,
batchTimeout: 15000,
url: ConfigProvider.HOST + '/log/store/JSNLog'
})

//logger console
var consoleLogger = JL.createConsoleAppender('consoleAppender');

JL().setOptions({
appenders: [ajaxLogger, consoleLogger],
});
*/

/*
Errori senza crash
*/
export class UncaughtExceptionHandler implements ErrorHandler {
	constructor() {}

	handleError(e: Error): void {
		if(e.toString() == 'cordova_not_available' || (e.message && e.message.endsWith('cordova_not_available'))) {
			console.warn("Impossibile completare l'azione su browser, cordova non presente:", e.message, e.stack)
		} else if(e.message && e.message.indexOf("navigation stack needs at least one root page") >= 0) {
			console.warn("Eseguito un nav.pop() di troppo:", e.message, e.stack)
		} else {
			try {
				//TODO Disattivato perchè produce errore che blocca le U.I.
				//JL().fatalException("Errore non gestito!", e);
				console.error('Errore non gestito', e)
			} catch(e2) {
				try {
					console.error('Impossibile gestire l\'errore', e2)
				} catch(e3) {
					console.error('Impossibile gestire l\'errore o loggarlo')
				}
			}
		}/* else {
			//console.error('Errore non gestito:', e.message, e.stack);
			let message;
			//let serialization = null;
			try {
			//log errore intero
			console.error('Dettagli errore:', e);
			message = 'Errore non gestito: ' + e.message;
		} catch (e2) {
		//loop di referenze, errore non serializzabile
		try {
		console.error('Errore non gestito, non serializzabile:', e.message, e.stack, e2);
		message = 'Errore non gestito, non serializzabile: ' + e.message;
		//serialization = e.stack;
	} catch (e3) {
	//altro casino non gestibile lenna lettura dei campi
	console.error('Errore non gestito, non serializzabile:', e3.message, e3.stack);
	message = 'Errore con messaggio o stack inaccessibili: ' + e3.message
	//serialization = e3.stack
}
}

Logger.error(message, e)
}
*/
	}
}
/*
JL.setOptions({
defaultAjaxUrl: '/api/log/store/JSNLog',
})
*/


@NgModule({
	declarations: [
		ClientApp,
	],
	imports: [
		BrowserModule,
		IonicModule.forRoot(ClientApp,
			{
				monthNames: ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', ' agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'],
				monthShortNames: ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'],
				dayNames: ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'],
				dayShortNames: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
			}
		),
		IonicStorageModule.forRoot(),
		HttpModule,
		HttpClientModule,
		CalendarModule,
		//RoundProgressModule,//Progress bar rounded

		ComponentsModule,

		//PipesModule,

		AddressCreatePageModule,
		AddressEditPageModule,
		CallPageModule,
		CondominiumEditPageModule,
		CondominiumIndexPageModule,
		CondominiumIntercomPageModule,
		CondominiumShowPageModule,
		CondominiumWritePageModule,
		ControlPanelPageModule,
		CreditsModalPageModule,
		DashboardPageModule,
		DeviceEditPageModule,
		DeviceIndexPageModule,
		DeviceShowPageModule,
		LoginPageModule,
		HeatingConsumptionPageModule,
		HistoryPageModule,
		HousingUnitCreatePageModule,
		HousingUnitEditPageModule,
		HousingUnitIndexPageModule,
		HousingUnitIntercomPageModule,
		HousingUnitShowPageModule,
		HousingUnitUserCreatePageModule,
		//IncomingPageModule,
		MessageCreateAudioPageModule,
		MessageCreateIntercomPageModule,
		MessageCreatePageModule,
		MessageCreateReportPageModule,
		MessageShowPageModule,
		MessageModalPageModule,
		SettlementModalPageModule,
		TabMessagesPageModule,
		TabCallsPageModule,
		TimetableModalPageModule,
		UserAddPageModule,
		UserEditPageModule,
		UserIndexPageModule,
		UserShowPageModule,
	],
	bootstrap: [IonicApp],
	entryComponents: [
		AddressCreatePage,
		AddressEditPage,
		CallPage,
		/*
		CallOutgoingPage,
		CallIncomingPage,
		*/
		ClientApp,
		CondominiumEditPage,
		CondominiumIndexPage,
		CondominiumIntercomPage,
		CondominiumShowPage,
		CondominiumWritePage,
		ControlPanelPage,
		DashboardPage,
		DeviceEditPage,
		DeviceIndexPage,
		DeviceShowPage,
		LoginPage,
		HeatingConsumptionPage,
		HistoryPage,
		HousingUnitCreatePage,
		HousingUnitEditPage,
		HousingUnitIndexPage,
		HousingUnitIntercomPage,
		HousingUnitShowPage,
		//IncomingPage,
		MessageCreatePage,
		MessageCreateIntercomPage,
		MessageCreateReportPage,
		MessageShowPage,
		MessageModalPage,
		SettlementModalPage,
		TabMessagesPage,
		TabCallsPage,
		HousingUnitUserCreatePage,
		UserAddPage,
		UserEditPage,
		UserIndexPage,
		UserShowPage,
	],
	providers: [
		{ provide: ErrorHandler, useClass: UncaughtExceptionHandler/*IonicErrorHandler*/ },
		{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true, },
		{ provide: HTTP_INTERCEPTORS, useClass: IdentifierInterceptor, multi: true },

		{ provide: LOCALE_ID, useValue: "it-IT" },

		AccountProvider,
		AndroidBridgeProvider,
		AuthProvider,
		AddressProvider,
		FlavourProvider,
		LocationProvider,
		CondominiumProvider,
		ConfigProvider,
		DeviceProvider,
		HousingUnitProvider,
		InterappProvider,
		MessageProvider,
		SecurityCamProvider,
		//SignalingFirebaseProvider,
		SignalingSocketIoProvider,
		UserProvider,
		WebrtcProvider,

		/*
		PLUGIN NATIVI
		*/
		AndroidFullScreen,
		AndroidPermissions,
		Autostart,
		Badge,
		BackgroundMode,
		//DatePicker, NON FUNZIONA SU WEB
		Device,
		File,
		FileTransfer,
		Insomnia,
		LocalNotifications,
		Media,
		NativeAudio,
		//NativeRingtones,//recupera l'elendo delle suonerie disponibili, non funziona riproducendo un file custom
		NavigationBar,
		Network,
		OpenNativeSettings,
		ScreenOrientation,
		//SplashScreen,
		//Statusbar,
		TextToSpeech,
		UniqueDeviceID,
		AudioProvider,
		//WebIntent
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts